import { Component } from '@angular/core';
import { ScrollService } from '../providers/scroll.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-register-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    imports: [TranslatePipe]
})
export class NavigationComponent {

    constructor(private scroll: ScrollService) {
    }

    scrollTo(stepNumber: string) {
        this.scroll.scrollTo(stepNumber);
    }
}
